import { EBOOK_PDF } from 'global/constants';
import DocumentEdit from '../document/document-edit-drawer';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import { EditProps } from './ebook.constants';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';

const EbookSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <DocumentEdit title={getStimulusLabel(EBOOK_PDF)} {...props} />
  ) : (
    <StimulusLibrary
      title={getStimulusLabel(EBOOK_PDF)}
      stimulusType={EBOOK_PDF}
      componentId={props.id}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={EBOOK_PDF}
        />
      }
      {...props}
    />
  );
};

export default EbookSettings;
